export const firstColor = '#41d3be';

//Light
export const backgroundLight  = '#f1f1f1';
export const ContentCardBackgroundLight = '#f1f1f1';
export const textBackgroundLight = 'grey';

// Dark
export const backgroundDark = '#363537';
export const ContentCardBackgroundDark = '#5c5b5e';
export const textBackgroundDark = '#fafafa';